import * as React from 'react';

import {FlashBanner} from 'shells/flash-banner/flash-banner';
import {Body} from 'shells/typography/body';

export const PHONE_NUMBER_THROTTLED = 'PHONE_NUMBER_THROTTLED';
export const PHONE_NUMBER_NO_INTL_CALL_VERIFICATION_DURING_TRIAL =
    'PHONE_NUMBER_NO_INTL_CALL_VERIFICATION_DURING_TRIAL';
export const PHONE_NUMBER_OTHER_VERIFICATION_ERROR = 'PHONE_NUMBER_OTHER_VERIFICATION_ERROR';
export const PHONE_NUMBER_INVALID_VERIFICATION_NUMBER = 'PHONE_NUMBER_INVALID_VERIFICATION_NUMBER';
export const PHONE_NUMBER_ALREADY_VALIDATED = 'PHONE_NUMBER_ALREADY_VALIDATED';
export const PHONE_NUMBER_NEW_INSTANCE_AND_REQUIRES_VERIFICATION =
    'PHONE_NUMBER_NEW_INSTANCE_AND_REQUIRES_VERIFICATION';

export type SetupError =
    | 'PHONE_NUMBER_THROTTLED'
    | 'PHONE_NUMBER_NO_INTL_CALL_VERIFICATION_DURING_TRIAL'
    | 'PHONE_NUMBER_OTHER_VERIFICATION_ERROR'
    | 'PHONE_NUMBER_INVALID_VERIFICATION_NUMBER'
    | 'PHONE_NUMBER_ALREADY_VALIDATED'
    | 'PHONE_NUMBER_NEW_INSTANCE_AND_REQUIRES_VERIFICATION';

export const ERROR_CODE_MAP: {
    [key: string]: SetupError;
} = {
    '102': PHONE_NUMBER_THROTTLED,
    '103': PHONE_NUMBER_NO_INTL_CALL_VERIFICATION_DURING_TRIAL,
    '104': PHONE_NUMBER_OTHER_VERIFICATION_ERROR,
    '105': PHONE_NUMBER_INVALID_VERIFICATION_NUMBER,
    '106': PHONE_NUMBER_NEW_INSTANCE_AND_REQUIRES_VERIFICATION,
    '107': PHONE_NUMBER_ALREADY_VALIDATED,
};

export function getErrorMessageFromCode(errorCode: SetupError): string {
    switch (errorCode) {
        case PHONE_NUMBER_NO_INTL_CALL_VERIFICATION_DURING_TRIAL:
            return 'During your trial, Click-to-Call is only available for U.S. phone numbers. Purchase a Pro plan for international calling';
        case PHONE_NUMBER_INVALID_VERIFICATION_NUMBER:
            return 'The number you’re trying to validate is incorrectly formatted';
        case PHONE_NUMBER_NEW_INSTANCE_AND_REQUIRES_VERIFICATION:
            return 'Click-to-Call requires verification. Please contact our support team to test this feature.';
        case PHONE_NUMBER_THROTTLED:
            return 'Your account has been throttled for Click-to-Call. Please contact our support team for more information.';
        default:
            return 'There was a problem verifying your number. Please try again or contact support';
    }
}

export function getErrorFlashBannerFromCode(
    errorCode: SetupError
): React.ReactNode | null | undefined {
    switch (errorCode) {
        case PHONE_NUMBER_NO_INTL_CALL_VERIFICATION_DURING_TRIAL:
            return (
                <FlashBanner type='error' className='pb-24'>
                    <Body color='error'>
                        During your trial, Click-to-Call is only available for U.S. phone numbers.{' '}
                        <Body color='blue'>
                            <a href='/setup/billing/sales'>
                                Purchase a Pro plan for international calling
                            </a>
                        </Body>
                    </Body>
                </FlashBanner>
            );
        case PHONE_NUMBER_NEW_INSTANCE_AND_REQUIRES_VERIFICATION:
            return (
                <FlashBanner type='error' className='pb-24'>
                    <Body color='error'>
                        Click-to-Call requires verification. Please{' '}
                        <Body color='blue'>
                            <a href='https://support.nutshell.com/'>contact our support team</a>
                        </Body>{' '}
                        to test this feature.
                    </Body>
                </FlashBanner>
            );
        case PHONE_NUMBER_THROTTLED:
            return (
                <FlashBanner type='error' className='pb-24'>
                    <Body color='error'>
                        Your account has been throttled for Click-to-Call. Please{' '}
                        <Body color='blue'>
                            <a href='https://support.nutshell.com/'>contact our support team</a>{' '}
                        </Body>
                        for more information.
                    </Body>
                </FlashBanner>
            );
        case PHONE_NUMBER_INVALID_VERIFICATION_NUMBER:
            return (
                <FlashBanner type='error' className='pb-24'>
                    <Body color='error'>
                        The number you’re trying to validate is incorrectly formatted
                    </Body>
                </FlashBanner>
            );
        default:
            return (
                <FlashBanner type='error' className='pb-24'>
                    <Body color='error'>
                        There was a problem verifying your number. Please try again or contact
                        support
                    </Body>
                </FlashBanner>
            );
    }
}
